<template>
  <v-form @submit.prevent="addDomain">
    <v-row>
      <v-col cols="12" md="6" xl="4" class="pb-0">
        <gg-text-field
          label="Domain"
          name="Domain"
          v-model="domain"
          v-validate="'required|url'"
          :error-messages="errors.collect('Domain')"
        />
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-btn :loading="loading" @click="addDomain">
          Add Parked Domain
        </gg-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddAliasForm',
  data () {
    return {
      loading: false,
      domain: ''
    }
  },
  methods: {
    ...mapActions(['cpanel_api2', 'reportError', 'reportSuccess']),
    async addDomain () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      const data = {
        api2_module: 'Park',
        api2_method: 'park',
        domain: this.domain,
        _username: this.$route.query.user,
      }
      try {
        const response = await this.cpanel_api2(data)
        if (!response?.payload.error) {
          this.loading = false
          this.reportSuccess(`You created the parked domain “${data.domain}”.`)
          // this.clear()
          this.$emit('domain-created')
        } else {
          this.loading = false
          this.reportError(response.payload.error)
        }
      } catch (e) {
        this.loading = false
        this.reportError(e.resultmsg)
      }
    },
    clear () {
      this.domain = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    }
  },
}
</script>
